import { Dialog, DialogContent } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import { ModalProps } from '@mui/material/Modal';
import { RiCloseLine } from '@remixicon/react';

import { AgButton } from 'src/components/ui';

interface CustomModalProps extends Omit<ModalProps, 'title' | 'role'> {
  role?: DialogProps['role'];
  title: React.ReactNode;
  close: () => void;
}

export default function CustomModal({ children, title, close, ...props }: Omit<CustomModalProps, 'key'>) {
  return (
    <Dialog onClose={close} {...props} maxWidth="xl" fullWidth>
      <DialogContent>
        <div className="flex pb-3">
          <div className="grow text-lg">{title}</div>
          <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={close}>
            <RiCloseLine size={18} />
          </AgButton>
        </div>
        <div className="grow overflow-y-auto">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
